import Box, {Item} from "devextreme-react/box";
import {useContext} from "react";
import {OrderStatus} from "../../../../types/enums";
import {WorkOrderContext} from "../context/WorkOrderContext";
import CustomerInformationCard from "./CustomerInformationCard";
import PendingOrderCard from "./PendingOrderCard";
import WorkOrderInformationCard from "./WorkOrderInformationCard";
import StoreInformationCard from "./StoreInformationCard";

export default function WorkOrderInformationCards() {

	const { order } = useContext(WorkOrderContext);

	return (
		<>
			{
				order.details.orderStatusID === OrderStatus.Pending ?
					<PendingOrderCard />
					:
					<Box className='order-cards'>
						<Item ratio={1}>
							<WorkOrderInformationCard />
						</Item>
						<Item ratio={1}>
							<CustomerInformationCard />
						</Item>
						<Item ratio={1}>
							<StoreInformationCard />
						</Item>
					</Box>
			}
		</>
	)
}
